import { Link } from "react-router-dom";
import { PageHeader } from "@/components/ui";

export function NotFoundScreen() {
  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        eyebrow="404"
        title="No such screen"
        description="The link was probably to a screen that has since moved."
      />
      <Link to="/" className="text-[12.5px] text-accent hover:underline">
        Back to the dashboard
      </Link>
    </div>
  );
}
